'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout       from '@Layout/BackOffice'
import CreationForm from '@/Form/CreationForm'
import config       from '@Config/Configuration/age'

export default class NewAgePage extends React.Component
{
	constructor (props)
	{
		super(props);
	}

	componentWillMount ()
	{
		var component = this;

		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		var output =
		(
			<Layout page_title="Nouvelle tranche d'age" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<CreationForm config={ config } />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
